(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["deal-countdown-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deal-countdown-banner')) {
  class DealCountdownBanner extends HTMLElement {
    connectedCallback() {
      const endMs = Date.parse(this.dataset.endDate || '');
      const els = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };

      const setValues = (d, h, mi, s) => {
        if (els.days) {
          els.days.textContent = String(d);
        }

        if (els.hours) {
          els.hours.textContent = String(h).padStart(2, '0');
        }

        if (els.minutes) {
          els.minutes.textContent = String(mi).padStart(2, '0');
        }

        if (els.seconds) {
          els.seconds.textContent = String(s).padStart(2, '0');
        }
      };

      const tick = () => {
        if (!Number.isFinite(endMs)) {
          return;
        }

        const distance = endMs - Date.now();

        if (distance <= 0) {
          if (this.intervalId) {
            clearInterval(this.intervalId);
          }

          setValues(0, 0, 0, 0);
          return;
        }

        setValues(
          Math.floor(distance / 86400000),
          Math.floor((distance % 86400000) / 3600000),
          Math.floor((distance % 3600000) / 60000),
          Math.floor((distance % 60000) / 1000)
        );
      };

      if (Number.isFinite(endMs)) {
        tick();
        this.intervalId = setInterval(tick, 250);
      }
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }
  }

  customElements.define('deal-countdown-banner', DealCountdownBanner);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-configuration-showcase"] && !Shopify.designMode) return;
  try {
    class ProductConfigurationShowcase extends HTMLElement {
    #handleResize = () => {
      this.#syncMobileCollapse();
    };

    /** @param {string} v */
    #activeLabel(v) {
      return (v || '').trim();
    }

    connectedCallback() {
      this.#bindFilters();
      this.#bindShowMore();
      this.classList.add('product-configuration-showcase--ready');
      this.#syncMobileCollapse();
      window.addEventListener('resize', this.#handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.#handleResize);
    }

    #bindFilters() {
      const buttons = this.querySelectorAll('[data-pcf-filter]');
      const cards = this.querySelectorAll('[data-pcf-card]');
      if (!buttons.length || !cards.length) {
        return;
      }

      for (const button of buttons) {
        button.addEventListener('click', () => {
          const raw = button.dataset.pcfValue || '';
          const isAll = raw === 'all';
          for (const btn of buttons) {
            const pressed = btn === button;
            btn.classList.toggle('product-configuration-showcase__pill--active', pressed);
            btn.setAttribute('aria-pressed', String(pressed));
          }
          for (const card of cards) {
            const value = this.#activeLabel(card.dataset.pcfValue || '');
            if (isAll) {
              card.removeAttribute('hidden');
              continue;
            }
            if (!value) {
              card.setAttribute('hidden', '');
              continue;
            }
            if (this.#activeLabel(value) === this.#activeLabel(raw)) {
              card.removeAttribute('hidden');
            } else {
              card.setAttribute('hidden', '');
            }
          }
          this.#setExpanded(false);
          requestAnimationFrame(() => this.#syncMobileCollapse());
        });
      }
    }

    #bindShowMore() {
      const button = this.querySelector('[data-pcf-show-more]');
      if (!button) {
        return;
      }

      button.addEventListener('click', () => {
        this.#setExpanded(true);
      });
    }

    /** @param {boolean} isExpanded */
    #setExpanded(isExpanded) {
      const button = this.querySelector('[data-pcf-show-more]');
      this.classList.toggle('product-configuration-showcase--expanded', isExpanded);
      if (button) {
        button.setAttribute('aria-expanded', String(isExpanded));
      }
    }

    #syncMobileCollapse() {
      const grid = this.querySelector('[data-pcf-grid]');
      if (!grid) {
        return;
      }

      const cards = Array.from(grid.querySelectorAll('[data-pcf-card]')).filter((card) => !card.hasAttribute('hidden'));
      const firstCard = cards[0];
      if (!firstCard) {
        this.dataset.pcfCollapsible = 'false';
        this.#setExpanded(false);
        grid.style.removeProperty('--pcf-mobile-collapse-height');
        this.style.removeProperty('--pcf-mobile-fade-start');
        return;
      }

      const firstRowTop = firstCard.offsetTop;
      const firstRowCount = cards.filter((card) => Math.abs(card.offsetTop - firstRowTop) < 2).length || 1;
      const isCollapsible = cards.length > firstRowCount;
      this.dataset.pcfCollapsible = String(isCollapsible);

      if (!isCollapsible) {
        this.#setExpanded(false);
        grid.style.removeProperty('--pcf-mobile-collapse-height');
        this.style.removeProperty('--pcf-mobile-fade-start');
        return;
      }

      const rowGap = Number.parseFloat(window.getComputedStyle(grid).rowGap) || 0;
      const cardHeight = firstCard.getBoundingClientRect().height;
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const peekHeight = isDesktop ? Math.min(cardHeight * 0.32, 120) : Math.min(cardHeight * 0.16, 56);
      grid.style.setProperty('--pcf-mobile-collapse-height', `${Math.round(cardHeight + rowGap + peekHeight)}px`);
      this.style.setProperty('--pcf-mobile-fade-start', `${Math.round(cardHeight + rowGap)}px`);
    }
  }

  if (!customElements.get('product-configuration-showcase')) {
    customElements.define('product-configuration-showcase', ProductConfigurationShowcase);
  }
  } catch(e) { console.error(e); }
})();

})();
